var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.18182L9.50001 17M9.5 7.18182C10.5205 7.18182 11.3478 6.36779 11.3478 5.36364C11.3478 4.35948 10.5205 3.54545 9.5 3.54545M9.5 7.18182C8.47947 7.18182 7.65217 6.36779 7.65217 5.36364C7.65217 4.35948 8.47947 3.54545 9.5 3.54545M9.50001 1L9.5 3.54545M16.1522 14.4545L16.1523 17M16.1522 14.4545C17.1727 14.4545 18 13.6405 18 12.6364C18 11.6322 17.1727 10.8182 16.1522 10.8182M16.1522 14.4545C15.1316 14.4545 14.3043 13.6405 14.3043 12.6364C14.3043 11.6322 15.1316 10.8182 16.1522 10.8182M16.1523 1L16.1522 10.8182M2.84783 11.5455L2.84777 17M2.84783 11.5455C3.86835 11.5455 4.69565 10.7314 4.69565 9.72727C4.69565 8.72312 3.86835 7.90909 2.84783 7.90909M2.84783 11.5455C1.8273 11.5455 1 10.7314 1 9.72727C1 8.72312 1.8273 7.90909 2.84783 7.90909M2.84777 1L2.84783 7.90909",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-icon.e67b1c8a.svg";
export { ForwardRef as ReactComponent };